module.exports = __webpack_public_path__ + "static/img/4.642f851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-trans-terrestre-carga/4.png
// module id = +7qn
// module chunks = 0